import { createDynamicThunk } from ".";

/**
 * LIST Roles
 */
export const fetchRolesThunk = createDynamicThunk({
  typePrefix: "roles/fetchRolesThunk",
  useHandleSearch: true,
});

/**
 * ADD / EDIT Role
 */
export const submitRoleThunk = createDynamicThunk({
  typePrefix: "roles/submitRoleThunk",
  endpoint: "/roles",
  method: "POST",
});


export const fetchSectionsAsDropdownThunk = createDynamicThunk({
  typePrefix: "sections/fetchSectionsAsDropdownThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

export const fetchRolesBasedSectionsPermissionsThunk = createDynamicThunk({
  typePrefix: "fetchRolesBasedSectionsPermissionsThunk",
  endpoint: "/rolesBasedSectionsPermissions",
  method: "POST",
});